import { Expose, plainToInstance } from "class-transformer";
import camelcaseKeys from "camelcase-keys";

export class CustomerModel {
  @Expose()
  public customerId?: number;

  @Expose()
  public name?: string;

  @Expose()
  public mobile?: string;

  @Expose()
  public telephone?: string;

  @Expose()
  public mahale?: string;

  @Expose()
  public address?: string;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(CustomerModel, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(CustomerModel, camelcaseKeys(data, { deep: true }) as CustomerModel[], { excludeExtraneousValues: true });
  }
}
